// repo: https://vuemc.io/#basic-usage
import {Model, Collection} from 'vue-mc'
import {Organization} from "./organization";
import {FormPart} from "./form_part";
import {Section} from "./section";

class Program extends Model {
  defaults() {
    return {
      id:   null,
      name: "",
      administrative_fee_percentage: 0,
      addons: [],
      not_archived_addons: [],
      form_parts: [],
      sections: [],
      organization: new Organization(),
      allow_users_to_edit_sections: false,
      render_registration_state: 'closed',
      template_preview: false,
      cache: {},
      translations: {es:{},so:{},vi:{},it:{},pt:{}, ru:{},zh:{}, fr:{}},
      links: [],
      contacts: [],
      addresses: [],
      product_payment_methods: [],
      program_internal_fields: [],
      agreements: [],
      addresses_attributes: {},
      contacts_attributes: {},
      links_attributes: {},
      can_register_local: null,
      registrations_count: 0,
      student_transfers_attributes: {},
    }
  }
  mutations() {
    return {
      id:   (id) => Number(id) || null,
      administrative_fee_percentage: (x) => Number(x) || 0,
      max_total_price: (x) => Number(x) || 0,
      registrations_count: (x) => Number(x) || 0,
      sections: (arr)=>{ return arr.map(e=>{const o=new Section(e);o.program=this;return o})},
      form_parts: (arr)=>{ return arr.map((e)=>{
        let fp = new FormPart(e)
        fp.program=this
        return fp
      })},
    }
  }
  routes() {
    return {
      fetch: '/programs/{id}',
      save:  '/programs',
    }
  }

  isPersisted(){
    return !!this.id
  }
  isBlank(){
    return !this.isPersisted()
  }
  registration_open(){
    return this.render_registration_state==='open'
  }
  canRegister(){
    return this.canRegisterForSearch() && this.participantFormBlock()
  }
  participantFormBlock(){
    const part = this.participantFormPart() || {form_blocks: []}
    return part ? part.form_blocks.find(block=> block.style === "Product::FormBlock::PartPerson") : null
  }
  participantFormPart(){
    if (this.cache['participantFormPart']) return this.cache['participantFormPart']
    if (this.form_parts.length === 0) return {} // if not loaded yet
    return this.cache['participantFormPart'] = this.form_parts.find((part)=> part.style === 'RegistrantInformation' )
  }
  addressFormPart(){
    if (this.cache['addressFormPart']) return this.cache['addressFormPart']
    return this.cache['addressFormPart'] = this.form_parts.find((part)=> part.style === 'Address' )
  }
  canRegisterForSearch(){
    return this.isRegistrationPeriod() && this.anySectionsAvailable()
  }
  isRegistrationPeriod(){
    return ['open', 'full'].includes(this.render_registration_state)
  }

  // original sections.map(&:is_registration_period?).include?(true)
  // to be deleted as not needed
  anySectionsAvailable(){
    return this.isRegistrationPeriod()
    // for (let section of this.sections){
    //   if(this.is_section_registration_period(section)) return true
    // }
    // return false
  }

  // origin in Section model and
  // code is render_registration_state.in?(%w(open full))
  // is_section_registration_period(section){
  //   return ["open","full"].includes(section.render_registration_state)
  // }

  owned_by(org){
    return org.id === this.organization_id
  }
  can_register(){
    if(this.can_register_local) return this.can_register_local

    const part = this.form_parts.find(part=> part.style === 'RegistrantInformation')
    if(!part.id) return false
    const block = part.form_blocks.find(block => block.style === 'Product::FormBlock::PartPerson')
    if(!block.id) return false
    this.can_register_local =  ['open', 'full'].includes(this.render_registration_state)
    return this.can_register_local
  }
  is_deposit_allowed(){
    return this.deposit_allowed === true || this.deposit_allowed === 'true'

  }
  deposit_required(){
    return this.is_deposit_allowed() && this.overdeposit_payment_method === 'offline'

  }

}

export {
  Program
}
